module.exports = __webpack_public_path__ + "static/media/_wales.b20a0a0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_wales.svg
// module id = 2363
// module chunks = 7